<table>
    <tr>
        <th>No.</th>
        <th>Product Name</th>
        <th>SKU</th>
        <th>UPC</th>
    </tr>
    <tr *ngFor="let product of productList; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ product.title }} {{product.currency_data.symbol}}{{product.price_min}}<span *ngIf="product.price_min != product.price_max"> - {{product.currency_data.symbol}}{{product.price_max}}</span></td>
        <td>{{product.id}}</td>
        <td>{{product.upc}}</td>
    </tr>
</table>

<!-- <div *ngIf="productList">
    <div *ngFor="let product of productList.results">
        <div class="product-card" *ngIf="!product.hide_range">
            <div class="d-flex">
                <div class="product-avatar">
                    <img class="product-image" src="{{ product.image }}">
                </div>
                <div class="product-info">
                    <h3>
                            
                            <span>
                                UPC: <b>{{ product.upc }}</b>
                            </span>
                    </h3>
                    
                    <div *ngFor="let suggestion of product.suggestions">
                        <h3>
                                {{ product.title }} {{suggestion.title}} {{product.currency_data.symbol}}{{suggestion.price}}
                                <span>
                                    UPC: <b>{{ suggestion.upc || product.upc }}</b>
                                </span>
                        </h3>
                    </div>
                </div>
            </div>
            <hr>
            <div [innerHTML]="getProductDescription(product)"></div>
        </div>
        <div class="product-card" *ngFor="let suggestion of product.suggestions">
            <div class="d-flex">
                <div class="product-avatar">
                    <img class="product-image" src="{{ product.image }}">
                    <p>UPC: <b>{{ suggestion.upc || product.upc }}</b></p>
                </div>
                <div class="product-info">
                    <h3>
                        <b>
                            {{ product.title }} {{suggestion.title}} {{product.currency_data.symbol}}{{suggestion.price}}
                        </b>
                    </h3>
                    <div [innerHTML]="getProductDescription(product)"></div>
                </div>
            </div>
        </div> 
    </div>
</div> -->